import React from "react";
import { Checkbox, Row, Col, Space, Tooltip, Select, Tag } from "antd";
import {
    EditFilled, PrinterFilled,
    UngroupOutlined, DeleteOutlined, CloudUploadOutlined,
    FileImageOutlined, FileTextOutlined, AppstoreOutlined,
    CommentOutlined, DatabaseOutlined, TagsOutlined,
    ArrowUpOutlined, ArrowDownOutlined, WarningOutlined,
    EyeOutlined
} from "@ant-design/icons";
import {
    FormItem, InputNumberItem, SelectItem,
    SelectInsumosItem, ButtonItem, dineroDisabledMask
} from "./Items";
import BotonAutorizacion from "./AutorizacionRapida/BotonAutorizacion";
import BotonDescripcionLarga, { textoDescripcionLarga, imprimeDescripcionLarga } from "./BotonDescripcionLarga";


import { getTotalesPaquete } from "../Utils/Paquetes.utils";

const { Option } = Select;

export const FilaInsumoCotizacion = ({
    field,
    index,
    form,
    insumosValues,
    estado,
    funciones,
    modoLectura = false,
    // Rendija dentro de modoLectura: la pantalla habilita SOLO el precio unitario (y su
    // gemelo con impuestos) dejando cantidad, descuento, insumo y proyecto bloqueados.
    // Lo usa EditarCotizacion cuando la cotizacion ya se convirtio: el precio se puede
    // recotizar, la cantidad ya esta comprometida en la venta/pedido.
    permitirPrecioUnitario = false,
    tiposDescuento = {},
    // Complemento Escuela: columna Desc. Cliente (descuentoBase) y el % de Desc. Adic.
    // pasa a descuentoAdicional. Requiere funciones.onChangeDescuentoEscuela. Sin la
    // prop la fila se pinta igual que antes (VerCotizacion no la manda).
    escuela = false

}) => {

    const { name} = field;
    const itemActual = insumosValues[index] || {};
    const itemAnterior = index > 0 ? insumosValues[index - 1] : null;
    const itemSiguiente = index < estado.totalFilas - 1 ? insumosValues[index + 1] : null;
    const insumoId = itemActual.insumoId;
    const proyectoId = itemActual.proyectoId;
    const pid = itemActual._paqueteId;
    const prevPid = itemAnterior?._paqueteId;
    const esInicioDePaquete = pid && (pid !== prevPid);
    const esFinDePaquete = prevPid && (pid !== prevPid);

    const paqueteMeta = pid ? estado.paquetes.find(p => p.idInterno === pid) : null;
    const seMuestraDesglose = paqueteMeta ? paqueteMeta.imprimirDesglose : true;

    let totalesPaquete = { subtotal: 0, impuestos: 0, total: 0 };
    if (esInicioDePaquete) {
        totalesPaquete = getTotalesPaquete(pid, insumosValues);
    }

    const isCheckboxDisabled = !!pid && pid !== estado.paqueteEditadoId;

    const insumoOriginal = estado.todasInsumos.find(i => i._id === itemActual.insumoId);

    const mostrarMarbetes = insumoOriginal?.marbetes;
    const mostrarLotes = insumoOriginal?.lotesCaducidades;
    const mostrarAgrupaciones = insumoOriginal?.agrupaciones;
    const mostrarLeyenda = insumoOriginal?.leyendaVenta;
    const mostrarObservaciones = insumoOriginal?.observacionesVenta;
    const insumoCambio = insumoOriginal?.insumoCambio;

    const estaBloqueado = (campo) => {
        const tienePermiso = campo === "descuento"
            ? estado.permisos.permisoModificarDescuento
            : (estado.permisos.permisoModificarPrecioUnitario || insumoCambio);
        return !tienePermiso && !estado.autorizacionesFila?.[`${campo}:${index}`]?.accesoLibre;
    };
    // El permiso de PU sigue mandando: `permitirPrecioUnitario` solo levanta el candado del
    // modo lectura, no el del permiso ni el de la autorizacion rapida.
    const precioUnitarioEditable = (!modoLectura || permitirPrecioUnitario) && !estaBloqueado("precioUnitario");
    // El <td> de Paquete solo se pinta en captura. Todo colSpan de la fila tiene que usar esta
    // misma condicion o el renglon del paquete queda corrido respecto al de los insumos.
    const columnaPaquete = estado.mostrarDatosPaquete && !modoLectura;
    const mostrarImagen = insumoOriginal?.archivosPrincipal?.length > 0;
    const cargarImagen = insumoOriginal?.cargarImagen;
    const mostrarIconos = itemActual?.imprimirImagen;
    const modoImagen = itemActual?.modoImagen;
    // Descripcion larga: en captura va como boton en Acciones; en lectura esa columna no
    // existe, asi que el indicador va en la celda del insumo junto a los Tag de imagen.
    const tieneDescripcionLarga = !!textoDescripcionLarga(insumoOriginal);
    const indicadorDescripcionLarga = modoLectura && tieneDescripcionLarga && imprimeDescripcionLarga(itemActual, insumoOriginal);
    // Detalle del insumo (datos + imagenes): igual que la descripcion larga, en captura va en
    // Acciones y en lectura en la celda del insumo, porque ahi no existe la columna Acciones.
    const puedeVerDetalle = !!itemActual?.insumoId && !!funciones.abrirDetalleInsumo;
    const abrirDetalle = () => funciones.abrirDetalleInsumo(
        itemActual.insumoId,
        insumoOriginal?.nombreClienteAlternativo || insumoOriginal?.nombre || insumoOriginal?.descripcion || ''
    );

    // Violacion de las reglas de la lista de precios para este renglon, si la hay.
    // VerCotizacion no manda `fueraDeRango`, y ahi queda undefined a proposito.
    const violacionRegla = estado.fueraDeRango?.[index];

    const tooltipStyle = { fontSize: "10px", padding: "1px 5px", minHeight: "auto" };

    // Construir botones de imagen
    let buttonsImagen = [];    
    let buttonsAccion = [];

    if (estado.modoReordenar && !modoLectura) {
        // Paredes invisibles del paquete
        const disableUp = index === 0 || itemActual._paqueteId !== itemAnterior?._paqueteId;
        const disableDown = index === estado.totalFilas - 1 || itemActual._paqueteId !== itemSiguiente?._paqueteId;

        buttonsAccion.push(
            <ButtonItem
                key="btn-up" type="primary" size="small"
                disabled={disableUp}
                cyan
                onClick={() => funciones.move(index, index - 1)}
                icon={<ArrowUpOutlined />}
                lessTime
            />
        );

        buttonsAccion.push(
            <ButtonItem
                key="btn-down" type="primary" size="small"
                disabled={disableDown}
                naranja
                onClick={() => funciones.move(index, index + 1)}
                icon={<ArrowDownOutlined />}
                lessTime
            />
        );
    } else {
        if (!modoLectura) {
            if (estado.mostrarImprimirImagen && mostrarImagen) {
                buttonsImagen.push(
                    <Tooltip key="tip-insumo" title="Usar imagen del catálogo" placement="top" overlayInnerStyle={tooltipStyle}>
                        <ButtonItem
                            key="btn-img-insumo"
                            type="dashed" size="small"
                            icon={<FileImageOutlined />}
                            verde={modoImagen === 'insumo'}
                            blanco={modoImagen !== 'insumo'}
                            onClick={() => funciones.seleccionarModoImagen(index, 'insumo')}
                            onContextMenu={(e) => funciones.abrirVistaPreviaInsumo(index, e)}
                        />
                    </Tooltip>
                );
            }

            if (estado.mostrarImprimirImagen && (cargarImagen || insumoCambio)) {
                buttonsImagen.push(
                    <Tooltip key="tip-cargar" title="Subir imagen personalizada" placement="top" overlayInnerStyle={tooltipStyle}>
                        <ButtonItem
                            key="btn-img-cargar"
                            type="dashed" size="small"
                            icon={<CloudUploadOutlined />}
                            verde={modoImagen === 'cargar'}
                            blanco={modoImagen !== 'cargar'}
                            onClick={() => funciones.abrirModalImagen(index)}
                        />
                    </Tooltip>
                );
            }
        } else if (mostrarIconos) {
            if (modoImagen === 'insumo') {
                buttonsImagen.push(
                    <Tooltip key="tip-insumo-ro" title="Imagen de catálogo utilizada">
                        <FileImageOutlined style={{ fontSize: '20px', color: '#52c41a', cursor: 'pointer' }} />
                    </Tooltip>
                );
            }
            if (modoImagen === 'cargar') {
                buttonsImagen.push(
                    <Tooltip key="tip-cargar-ro" title="Imagen personalizada utilizada">
                        <CloudUploadOutlined style={{ fontSize: '20px', color: '#52c41a', cursor: 'pointer' }} />
                    </Tooltip>
                );
            }
        }
        // Construir botones de acción (leyenda, marbetes, lotes, agrupaciones, observaciones, eliminar)
        if (!modoLectura) {
            if (puedeVerDetalle) {
                buttonsAccion.push(
                    <Tooltip key="tip-detalle" title="Ver detalle del insumo" placement="top" overlayInnerStyle={tooltipStyle}>
                        <ButtonItem
                            key="btn-detalle"
                            type="primary" size="small"
                            cyan
                            icon={<EyeOutlined />}
                            onClick={abrirDetalle}
                        />
                    </Tooltip>
                );
            }
            if (mostrarLeyenda) {
                buttonsAccion.push(
                    <Tooltip key="tip-leyenda" title="Agregar Leyenda" placement="top" overlayInnerStyle={tooltipStyle}>
                        <ButtonItem
                            key="btn-leyenda"
                            type="primary" size="small"
                            icon={<FileTextOutlined />}
                            lima2
                            verde={itemActual.leyenda}
                            onClick={() => funciones.abrirLeyenda(index, itemActual.leyenda, insumoId)}
                        />
                    </Tooltip>
                );
            }
    
            if (mostrarMarbetes) {
                buttonsAccion.push(
                    <Tooltip key="tip-marbetes" title="Marbetes" placement="top" overlayInnerStyle={tooltipStyle}>
                        <ButtonItem
                            key="btn-marbetes"
                            type="primary" size="small"
                            cyan2
                            icon={<TagsOutlined />}
                            onClick={() => funciones.abrirElegirMarbetes(index, itemActual.marbetes, insumoId, proyectoId)}
                        />
                    </Tooltip>
                );
            }
    
            if (mostrarAgrupaciones) {
                buttonsAccion.push(
                    <Tooltip key="tip-agrupaciones" title="Agrupaciones" placement="top" overlayInnerStyle={tooltipStyle}>
                        <ButtonItem
                            key="btn-agrupaciones"
                            type="primary" size="small"
                            cyan2
                            icon={<AppstoreOutlined />}
                            onClick={() => funciones.abrirElegirAgrupaciones(index, itemActual.agrupaciones, insumoId, proyectoId)}
                        />
                    </Tooltip>
                );
            } else if (mostrarLotes) {
                buttonsAccion.push(
                    <Tooltip key="tip-lotes" title="Lotes" placement="top" overlayInnerStyle={tooltipStyle}>
                        <ButtonItem
                            key="btn-lotes"
                            type="primary" size="small"
                            amarillo2
                            icon={<DatabaseOutlined />}
                            onClick={() => funciones.abrirElegirLotes(index, itemActual.lotes, insumoId, proyectoId, itemActual.cantidad)}
                        />
                    </Tooltip>
                );
            }
    
            if (tieneDescripcionLarga && funciones.toggleDescripcionLarga) {
                buttonsAccion.push(
                    <BotonDescripcionLarga
                        key="btn-desc-larga"
                        renglon={itemActual}
                        insumoOriginal={insumoOriginal}
                        onToggle={(valor) => funciones.toggleDescripcionLarga(index, valor)}
                    />
                );
            }

            if (mostrarObservaciones) {
                buttonsAccion.push(
                    <Tooltip key="tip-observaciones" title="Agregar Observaciones" placement="top" overlayInnerStyle={tooltipStyle}>
                        <ButtonItem
                            key="btn-observaciones"
                            type="primary" size="small"
                            cyan2
                            icon={<CommentOutlined />}
                            verde={itemActual.observaciones}
                            onClick={() => funciones.abrirObservaciones(index, itemActual.observaciones, insumoId, itemActual.observacionesXml)}
                        />
                    </Tooltip>
                );
            }
    
            buttonsAccion.push(
                <ButtonItem
                    key="btn-del"
                    rojo2
                    icon={<DeleteOutlined />}
                    onClick={() => funciones.remove(name)}
                    size="small"
                    lessTime
                />
            );
        }
    }


    // Cuenta real de <td> del renglon principal. En modo lectura no se pintan Inventario ni
    // la columna de acciones, asi que son dos menos. Escuela suma la de Desc. Cliente.
    const totalColumns = (modoLectura ? 10 : (columnaPaquete ? 13 : 12)) + (escuela ? 1 : 0);

    return (
        <React.Fragment key={field.key}>
            {esFinDePaquete && (
                <tr><td colSpan={totalColumns} style={{height: 15, backgroundColor: '#f0f2f5'}}></td></tr>
            )}

            {esInicioDePaquete && (
                <tr style={{ backgroundColor: '#e6f7ff', borderTop: '2px solid #1890ff' }}>
                    {/* Nombre del paquete */}
                    <td colSpan={columnaPaquete ? 6 : 5} className="td-border" style={{ padding: '8px' }}>
                        <div style={{display:'flex', alignItems:'center', gap: 10}}>
                            <span style={{ fontWeight: 'bold', color: '#096dd9', fontSize: '1.1em' }}>
                                {itemActual._nombrePaquete}
                            </span>
                        </div>
                    </td>

                    {/* Botones de control del paquete*/}
                    <td colSpan={modoLectura ? 2 : 3} className="td-border">
                        {!modoLectura && (
                            <div className="paquete-acciones-iconos" style={{display:'flex', justifyContent:'space-between', paddingLeft: 16, paddingRight: 16, alignItems:'center'}}>
                                <Tooltip title="Editar Paquete">
                                    <EditFilled
                                        style={{color: "green", fontSize: 22, cursor:'pointer'}}
                                        onClick={() => funciones.editarPaquete(pid)}
                                        disabled={estado.mostrarDatosPaquete}
                                    />
                                </Tooltip>
                                <Tooltip title={seMuestraDesglose ? "PDF: Se imprimirá el desglose" : "PDF: Solo se imprimirá el total"}>
                                    <PrinterFilled
                                        style={{color: seMuestraDesglose  ? "green" : "gray", fontSize: 19, cursor:'pointer'}}
                                        onClick={() => funciones.toggleImprimirDesglose(pid)}
                                    />
                                </Tooltip>
                                <Tooltip title="Desagrupar (Mantener insumos)">
                                    <UngroupOutlined
                                        style={{color: "orange", fontSize: 22, cursor:'pointer'}}
                                        onClick={() => funciones.desagruparPaquete(pid)}
                                    />
                                </Tooltip>
                                <Tooltip title="Eliminar Paquete y Contenido">
                                    <DeleteOutlined
                                        style={{color: "red", fontSize: 22, cursor:'pointer'}}
                                        onClick={() => funciones.eliminarPaqueteCompleto(pid)}
                                    />
                                </Tooltip>
                            </div>
                        )}
                    </td>

                    {/* Input Cantidad Paquete */}
                    <td className="td-border" style={{ textAlign: 'center'}}>
                        <InputNumberItem
                            value={paqueteMeta?.cantidad || 1}
                            min={1}
                            disabled={modoLectura}
                            onChange={(val) => !modoLectura && funciones.onChangeCantidadPaquete(pid, val)}
                            style={{ width: 60 }}
                            size="small"
                        />
                    </td>

                    {/* Empty: Desc. Cliente column (complemento Escuela) */}
                    {escuela && <td className="td-border"></td>}
                    {/* Empty: Descuento column */}
                    <td className="td-border"></td>
                    {/* Totales del Paquete */}
                    <td className="td-border" style={{ textAlign: 'right', fontWeight:'bold', fontSize: '14px' }}>
                        <div className="celda-totales">
                            <div>{dineroDisabledMask(totalesPaquete.subtotal || 0)}</div>
                            <div>{dineroDisabledMask(totalesPaquete.impuestos || 0)}</div>
                            <div className="total-bold">Total: {dineroDisabledMask(totalesPaquete.total || 0)}</div>
                        </div>
                    </td>
                    {/* Empty: Acciones column (solo existe en modo edición) */}
                    {!modoLectura && <td className="td-border-sin-right"></td>}
                </tr>
            )}

            <tr style={{ backgroundColor: pid ? '#fafafa' : 'white' }}>
                    {/* No. */}
                    <td className="td-border">
                        <div style={{ fontSize: '14px', textAlign: 'center', color: '#868585' }}>
                            {index + 1}
                        </div>
                    </td>
                    {/* Checkbox para Selección de Paquete */}
                    {columnaPaquete && (
                        <td className="td-border" style={{ textAlign: 'center' }}>
                            <Checkbox
                                disabled={isCheckboxDisabled}
                                checked={estado.indicesSeleccionadosPaquete.includes(index)}
                                onChange={(e) => funciones.onCheckInsumoPaquete(e, index)}
                            />
                        </td>
                    )}

                    {/* Código */}
                    <td
                        className="td-border"
                        onDoubleClick={() => {
                            if (modoLectura && funciones.abrirDisponibilidad && insumoId) {
                                const proyectoId = form?.getFieldValue(['insumos', index, 'proyectoId']);
                                funciones.abrirDisponibilidad(insumoId, insumoOriginal?.nombreClienteAlternativo || insumoOriginal?.nombre || insumoOriginal?.descripcion || '', proyectoId);
                            }
                        }}
                        // El clic derecho NO se condiciona a modoLectura: esta celda siempre se
                        // renderiza y el historial es igual de util en captura que en lectura.
                        // Tampoco se filtra por insumoId: que abrirHistorialCliente emita el aviso
                        // es mejor que un no-op silencioso.
                        onContextMenu={(e) => {
                            e.preventDefault();
                            funciones.abrirHistorialCliente?.(insumoId, insumoOriginal?.nombreClienteAlternativo || insumoOriginal?.nombre || insumoOriginal?.descripcion || '', index);
                        }}
                        title="Doble clic: disponibilidad · Clic derecho: historial con este cliente"
                        style={{ cursor: (modoLectura && funciones.abrirDisponibilidad) ? 'pointer' : 'default' }}
                    >
                        <div style={{ fontSize: '14px', textAlign: 'center', color: '#868585', whiteSpace: 'normal', wordBreak: 'break-word' }}>
                            {insumoOriginal?.claveClienteAlternativa || insumoOriginal?.clave || '-'}
                        </div>
                    </td>

                    {/* Select Insumo */}
                    <td className="td-border">
                        <FormItem {...field} name={[field.name, "insumoId"]} required noStyle>
                            {modoLectura ? (
                                <SelectItem
                                    sinBorde
                                    disabled
                                    noDisabledBackground
                                    width="100%"
                                    placeholder="Insumo"
                                    style={{ boxShadow: 'none', whiteSpace: 'normal', wordBreak: 'break-word', height: 'auto', minHeight: '32px'}}
                                >
                                    {estado.todasInsumos?.map(insumo => (
                                        <Option key={insumo._id} value={insumo._id}>
                                            {insumo.nombreClienteAlternativo || insumo.nombre || insumo.descripcion}
                                        </Option>
                                    ))}
                                </SelectItem>
                            ):
                            (
                                <SelectInsumosItem
                                    empresaId={estado.empresaId}
                                    headersToken={estado.headersToken}
                                    clienteId={estado.clienteId}
                                    usarPrecioCliente={estado.usarPrecioCliente}
                                    sinBorde
                                    autoFocus
                                    ocultarCodigoYUnidad
                                    focusTdIndex={3}
                                    disabled={modoLectura}
                                    width="100%"
                                    placeholder="Insumo"
                                    insumoPreCargado={insumoOriginal}
                                     style={{ boxShadow: 'none', whiteSpace: 'normal', wordBreak: 'break-word', height: 'auto', minHeight: '32px'}}
                                    onChange={(value, insumo) => funciones.onChangeInsumoProyecto(value, index, 'insumo', false, insumo)}
                                />
                            )}
                        </FormItem>
                        {insumoOriginal?.nombreClienteAlternativo && (
                            <div style={{ fontSize: 11, color: '#999', whiteSpace: 'normal', marginTop: 2 }}>
                                {insumoOriginal.descripcion}
                            </div>
                        )}
                        {modoLectura && (puedeVerDetalle || modoImagen || indicadorDescripcionLarga) && (
                            <div style={{ paddingLeft: 6, paddingBottom: 4 }}>
                                {puedeVerDetalle && (
                                    <span style={{ marginRight: 6 }}>
                                        <Tooltip title="Ver detalle del insumo" placement="top" overlayInnerStyle={tooltipStyle}>
                                            <ButtonItem
                                                type="primary" size="small"
                                                cyan
                                                icon={<EyeOutlined />}
                                                onClick={abrirDetalle}
                                            />
                                        </Tooltip>
                                    </span>
                                )}
                                {modoImagen === 'insumo' && (
                                    <Tag
                                    icon={<FileImageOutlined style={{ fontSize: 16 }} />}
                                    style={{
                                        borderRadius: 20,
                                        boxShadow: '0 2px 6px rgba(82,196,26,0.35)',
                                        backgroundColor: '#f6ffed',
                                        border: '1px solid #b7eb8f',
                                        color: '#389e0d',
                                        fontSize: 11,
                                        padding: '2px 10px',
                                        display: 'inline-flex',
                                        alignItems: 'center',
                                    }}
                                    >
                                    Imagen catálogo
                                    </Tag>
                                )}

                                {modoImagen === 'cargar' && (
                                    <Tag
                                    icon={<CloudUploadOutlined style={{ fontSize: 16 }} />}
                                    style={{
                                        borderRadius: 20,
                                        boxShadow: '0 2px 6px rgba(24,144,255,0.35)',
                                        backgroundColor: '#e6f7ff',
                                        border: '1px solid #91d5ff',
                                        color: '#096dd9',
                                        fontSize: 11,
                                        padding: '2px 10px',
                                        display: 'inline-flex',
                                        alignItems: 'center',
                                    }}
                                    >
                                    Imagen subida
                                    </Tag>
                                )}

                                {indicadorDescripcionLarga && (
                                    <BotonDescripcionLarga
                                        soloLectura
                                        renglon={itemActual}
                                        insumoOriginal={insumoOriginal}
                                    />
                                )}
                                </div>
                        )}
                    </td>

                    {/* Unidad */}
                    <td className="td-border">
                        <div style={{ fontSize: '14px', textAlign: 'center' }}>
                            {typeof insumoOriginal?.unidad === 'object'
                                ? (insumoOriginal?.unidad?.nombre || insumoOriginal?.unidad?.descripcion || '-')
                                : (insumoOriginal?.unidad || '-')}
                            {insumoOriginal?.presentacionCliente && (
                                <div style={{ fontSize: 11, color: '#999' }}>{insumoOriginal.presentacionCliente}</div>
                            )}
                        </div>
                    </td>

                    {/* Select Proyecto */}
                    <td className="td-border">
                        <FormItem shouldUpdate={(prev, curr) => prev.proyectoId !== curr.proyectoId} noStyle>
                            {() => (
                                <FormItem {...field} name={[field.name, "proyectoId"]} required noStyle initialValue={form.getFieldValue("proyectoId")}>
                                    <SelectItem
                                      
                                        sinBorde width="100%" placeholder="Proyecto"
                                        disabled={modoLectura}
                                        noDisabledBackground={modoLectura}
                                        onChange={(value) => funciones.onChangeInsumoProyecto(value, index, 'proyecto')}
                                    >
                                        {estado.objetoProyectos}
                                    </SelectItem>
                                </FormItem>
                            )}
                        </FormItem>
                    </td>

                    {/* Precio Unitario */}
                    <td className="td-border" onContextMenu={(e) => { e.preventDefault(); funciones.abrirVerInsumo(index); }}>
                        <div style={{ display: "flex", alignItems: "center" }}>
                            <div style={{ flex: 1 }}>
                                <FormItem {...field} name={[field.name, "precioUnitario"]} noStyle required numberCero>
                                    <InputNumberItem
                                        sinBorde
                                        onChange={(value) => funciones.onChangePrecioCantidadDescuento(value, index)}
                                        placeholder="Precio Unitario"
                                        dinero
                                        disabled={!precioUnitarioEditable}
                                    />
                                </FormItem>
                            </div>
                            {/* Aviso en vivo de las reglas de la lista de precios. No
                                bloquea la captura: el vendedor tiene que poder teclear el
                                valor para poder pedir autorizacion sobre el. */}
                            {violacionRegla?.campo === "precioUnitario" ? (
                                <Tooltip title={violacionRegla.motivo} overlayStyle={tooltipStyle}>
                                    <WarningOutlined style={{ color: "#faad14", marginLeft: 4 }} />
                                </Tooltip>
                            ) : null}
                            <BotonAutorizacion
                                visible={!!estado.autorizacionesRapidas && (!modoLectura || permitirPrecioUnitario) && !!insumoId && estaBloqueado("precioUnitario") && !!funciones.abrirModalAutorizacion}
                                onClick={() => funciones.abrirModalAutorizacion("precioUnitario", index)}
                            />
                        </div>
                    </td>

                   {/* Precio Con Impuestos */}
                    <td className="td-border">
                        <FormItem {...field} name={[field.name, "precioUnitarioConImpuestos"]} noStyle required>
                            <InputNumberItem
                                sinBorde
                                disabled={!precioUnitarioEditable}
                                placeholder="P/U + Imp"
                                dinero
                                onChange={(value) => {
                                    funciones.onChangePrecioConImpuestos(value, index);
                                }}
                            />
                        </FormItem>
                    </td>

                     {/* Inventario  */}
                    {!modoLectura && (
                        <td
                            className="td-border"
                            onDoubleClick={() => {
                                if (funciones.abrirDisponibilidad && insumoId) {
                                    const proyectoId = form?.getFieldValue(['insumos', index, 'proyectoId']);
                                    funciones.abrirDisponibilidad(insumoId, insumoOriginal?.nombreClienteAlternativo || insumoOriginal?.nombre || insumoOriginal?.descripcion || '', proyectoId);
                                }
                            }}
                            // Esta celda solo existe cuando !modoLectura, y la de Código solo
                            // cuando modoLectura: el clic derecho tiene que estar en las DOS o
                            // no existiria en la mitad de los modos.
                            onContextMenu={(e) => {
                                e.preventDefault();
                                funciones.abrirHistorialCliente?.(insumoId, insumoOriginal?.nombreClienteAlternativo || insumoOriginal?.nombre || insumoOriginal?.descripcion || '', index);
                            }}
                            title="Doble clic: disponibilidad · Clic derecho: historial con este cliente"
                            style={{ cursor: funciones.abrirDisponibilidad ? 'pointer' : 'default' }}
                        >
                            <div style={{ pointerEvents: 'none' }}>
                                <FormItem {...field} name={[field.name, "cantidadProyecto"]} noStyle>
                                    <InputNumberItem sinBorde disabled placeholder="Inv." />
                                </FormItem>
                            </div>
                        </td>
                    )}

                    {/* Cantidad */}
                    <td className="td-border">
                        <FormItem noStyle shouldUpdate={(prev, curr) => prev.insumos?.[index]?.cantidadProyecto !== curr.insumos?.[index]?.cantidadProyecto}>
                            {() => {
                                const cant = itemActual.cantidadProyecto;
                                const max = (cant === "No inventariable") ? Infinity : cant;
                                // Solo EditarCotizacion manda vendidoPorInsumo (cotizacion ya convertida).
                                // Es por insumo, no por renglon: asi liga la venta/pedido con la cotizacion.
                                const vendidoInsumo = estado.vendidoPorInsumo?.[String(insumoId?._id || insumoId)];
                                return (
                                    <>
                                        <FormItem {...field} name={[field.name, "cantidad"]} number noStyle type="number" required>
                                            <InputNumberItem
                                                sinBorde
                                                disabled={modoLectura}
                                                placeholder={max && max !== Infinity ? "Max: " + max : "Cant."}
                                                onChange={(value) => funciones.onChangePrecioCantidadDescuento(value, index)}
                                            />
                                        </FormItem>
                                        {vendidoInsumo > 0 && (
                                            <Tooltip title="Cantidad de este insumo ya vendida o pasada a pedido. La suma de sus renglones no puede quedar por debajo." overlayInnerStyle={tooltipStyle}>
                                                <div style={{ fontSize: 10, color: "#8c8c8c", lineHeight: 1.2, paddingLeft: 4 }}>
                                                    Vendido: {vendidoInsumo}
                                                </div>
                                            </Tooltip>
                                        )}
                                    </>
                                );
                            }}
                        </FormItem>
                    </td>

                    {/* Desc. Cliente (complemento Escuela) */}
                    {escuela && (
                        <td className="td-border">
                            <FormItem
                            {...field}
                            key={`desc-base-${index}`}
                            name={[name, "descuentoBase"]}
                            numberCero
                            noStyle
                            initialValue={0}
                            >
                            <InputNumberItem
                                disabled={modoLectura || estaBloqueado("descuento")}
                                sinBorde
                                placeholder="Desc. %"
                                porcentaje
                                max={100}
                                onChange={() => funciones.onChangeDescuentoEscuela(index)}
                            />
                            </FormItem>
                        </td>
                    )}

                    {/* Descuento */}
                    <td className="td-border">
                        <div style={{ display: "flex", alignItems: "center" }}>
                        <div style={{ flex: 1 }}>
                        {tiposDescuento[index] === 'cantidad' ? (
                            <FormItem
                            {...field}
                            key={`desc-cantidad-${index}`}
                            name={[name, "descuentoCantidad"]}
                            numberCero
                            noStyle
                            initialValue={0}
                            >
                            <InputNumberItem
                                disabled={modoLectura || estaBloqueado("descuento")}
                                sinBorde
                                placeholder="Desc. $"
                                dinero
                                onDoubleClick={() => funciones.onDobleClickDescuento(index)}
                                onChange={(value) =>
                                    funciones.onChangePrecioCantidadDescuento(value, index)
                                }
                            />
                            </FormItem>
                        ) : (
                            <FormItem
                            {...field}
                            key={`desc-porcentaje-${index}`}
                            name={[name, escuela ? "descuentoAdicional" : "descuento"]}
                            required
                            numberCero
                            noStyle
                            initialValue={0}
                            >
                            <InputNumberItem
                                disabled={modoLectura || estaBloqueado("descuento")}
                                sinBorde
                                placeholder="Desc. %"
                                porcentaje
                                max={100}
                                onDoubleClick={() => funciones.onDobleClickDescuento(index)}
                                onChange={(value) =>
                                    escuela
                                        ? funciones.onChangeDescuentoEscuela(index)
                                        : funciones.onChangePrecioCantidadDescuento(value, index)
                                }
                            />
                            </FormItem>
                        )}
                        </div>
                        {violacionRegla?.campo === "descuento" ? (
                            <Tooltip title={violacionRegla.motivo} overlayStyle={tooltipStyle}>
                                <WarningOutlined style={{ color: "#faad14", marginLeft: 4 }} />
                            </Tooltip>
                        ) : null}
                        <BotonAutorizacion
                            visible={!!estado.autorizacionesRapidas && !modoLectura && !!insumoId && estaBloqueado("descuento") && !!funciones.abrirModalAutorizacion}
                            onClick={() => funciones.abrirModalAutorizacion("descuento", index)}
                        />
                        </div>
                    </td>


                    {/* Subtotal / Impuesto / Total (unificado) */}
                    <td className="td-border">
                        <div className="celda-totales" style={{ fontSize: '12px' }}>
                            <div>{dineroDisabledMask(itemActual.subtotal || 0)}</div>
                            <div>{dineroDisabledMask(itemActual.impuestos || 0)}</div>
                            <div className="total-bold">Total: {dineroDisabledMask(itemActual.total || 0)}</div>
                        </div>
                        {/* Campos hidden para mantener los valores en el form */}
                        <FormItem {...field} name={[field.name, "subtotal"]} required numberCero hidden>
                            <InputNumberItem />
                        </FormItem>
                        <FormItem {...field} name={[field.name, "impuestos"]} required numberCero hidden>
                            <InputNumberItem />
                        </FormItem>
                        <FormItem {...field} name={[field.name, "total"]} required numberCero hidden>
                            <InputNumberItem />
                        </FormItem>
                    </td>

                    {/* Botones de Acción */}
                        {!modoLectura && (
                            <td className="td-border-sin-right">
                                <Row className="acciones-container">
                                    <Col span={24}>
                                        <Space
                                            style={{
                                                width: "100%",
                                                display: "flex",
                                                justifyContent: "space-between",
                                                alignItems: "center",
                                                backgroundColor: insumoCambio ? '#ffbbbbff' : 'transparent',
                                            }}
                                            size={0}
                                            className="acciones-container"
                                        >
                                            {buttonsImagen}
                                            {buttonsAccion}
                                        </Space>
                                    </Col>
                                </Row>
                            </td>
                        )}
                </tr>

                {/* Fila extra: Leyenda (si existe) */}
                {itemActual.leyenda && (
                    <tr className="fila-leyenda">
                        <td
                            colSpan={totalColumns}
                            className="td-border"
                            onDoubleClick={() => {
                                if (funciones.abrirAgregarInsumoCambio) {
                                    funciones.abrirAgregarInsumoCambio(index);
                                }
                            }}
                            style={{ cursor: funciones.abrirAgregarInsumoCambio ? 'pointer' : 'default' }}
                        >
                            <div className="contenedor-leyenda">
                                <div className="texto-leyenda">
                                    <b>Leyenda:</b> {itemActual.leyenda}
                                </div>
                            </div>
                        </td>
                    </tr>
                )}

                {/* Fila extra: Observaciones (si existen) */}
                {itemActual.observaciones && (
                    <tr>
                        <td colSpan={totalColumns} className="td-border-sin-right">
                            <div style={{ display: 'flex', justifyContent: 'left', alignItems: 'left', backgroundColor: itemActual.observacionesXml ? '#dceeffff' : 'white' }}>
                                <div style={{ width: '90%', textAlign: 'left', paddingLeft: 20 }}>
                                    {String(itemActual.observaciones).split(/\r?\n/).map((line, i) => <span key={i}>{line}<br /></span>)}
                                </div>
                            </div>
                        </td>
                    </tr>
                )}
        </React.Fragment>
    );
};